export default __webpack_public_path__ + "static/media/Snd_LowerMSwim.e8abb30a.mp3";